import React, { Component } from 'react';
import '../../stylesheet/loadersmall.css'

class LoaderSmall extends Component {
    render() {
        return (
            <div className="spinner">
            </div>
        )
    }
}

export default LoaderSmall;


// WEBPACK FOOTER //
// ./src/components/loader/loadersmall.jsx